import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import GuestHeader from "../pages/GuestHeader";
import GuestFooter from "../pages/GuestFooter";
import "../pages/LandingI18n/i18n";

function GuestLayout() {
  const location = useLocation();

  // Routes where footer should be hidden
  const hideFooterRoutes = ["/partner-signup",];

  const shouldHideFooter = hideFooterRoutes.includes(location.pathname);

  return (
    <div className="wrapper">
      <GuestHeader />
      <Outlet />
      {!shouldHideFooter && <GuestFooter />}
    </div>
  );
}

export default GuestLayout;
